import { useContext } from 'react';

import MyFavoriteContext from '@/src/context/MyFavoriteContext';

export default function useFavorites() {
  const context = useContext(MyFavoriteContext);
  if (!context) {
    throw new Error('useFavorites must be used within a FavoriteProvider');
  }
  return context;
}
